<template>
  <right-menu-item
    v-if="showEditBtn && !bcDocumentStore.edit"
    @click.prevent="clickEditBtn"
    class="!text-red-600"
    :text="$t('Edit')"
    :loading="loading"
    icon="pen"
    icon-class=""
  />
  
  <right-menu-item
    v-if="showEditBtn && bcDocumentStore.edit"
    @click.prevent="clickEditBtn"
    :text="$t('Preview changes')"
    :loading="loading"
    icon="eye-opened"
  />
</template>

<script>
import EditDocumentButton from '../../mixins/EditDocumentButton'

export default {
  mixins: [EditDocumentButton],
}
</script>

<style lang="scss" scoped></style>
